import { render, staticRenderFns } from "./AutomaticScoreReport.vue?vue&type=template&id=218c0d4a"
import script from "./AutomaticScoreReport.vue?vue&type=script&lang=js"
export * from "./AutomaticScoreReport.vue?vue&type=script&lang=js"
import style0 from "./AutomaticScoreReport.vue?vue&type=style&index=0&id=218c0d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports